import { useContext } from "react";
import { AppContext } from "../../common/contexts/app_context/app_context";

function BottomBar({ children }: { children: JSX.Element }) {
  const { navbarIsCollapsed } = useContext(AppContext)
  return (
    <div className={`fixed bottom-0 w-full h-16 z-30 bg-white border-t-[1px] border-border-light-gray dark:bg-background-dark dark:border-border-dark-gray transition-all duration-200 ${navbarIsCollapsed ? 'md:pr-16' : 'md:pr-64'}`}>
      {
        children
      }
    </div>
  );
}

export default BottomBar;